import React from 'react';
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm'
import rehypeRaw from "rehype-raw";
import styles from "./Markdown.module.scss";
import { MarkdownHeading } from './markdown-heading';

type Props = {
    markdown: string;
};

export const MarkdownRenderer = ({ markdown }: Props) => {
    return <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        className={styles.markdown}
        components={{
            h2(props) {
                return <MarkdownHeading level={2} children={props.children} />
            }
        }}
    >
        {markdown}
    </ReactMarkdown>;
}
